import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs';
import { NG_APP_API_ENDPOINT } from '@web-nx-ng-tsc/shared-constant';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({
  providedIn: 'root',
})
export class FormApiService {
  private readonly http = inject(HttpClient);
  private readonly loggingService = inject(LoggingService);

  // apiPath = 'https://tsc-api-dev.connecit.net/api';
  // getPromotionsItem(id: string) {
  //     return this.http
  //       .get(`${API_PATH}/PromotionGroupType/List?promotionGroupTypeId=${id}`)
  //       .pipe(tap((res: any) => this.loggingService.warn('[GET] PromotionsItem :: =>', res)));
  //   }

  getProvincesLists() {
    return this.http.get(`${NG_APP_API_ENDPOINT}/provinces`).pipe(
      map((res: any) => res.data),
      tap((res: any) => this.loggingService.warn('[GET] getProvincesLists :: =>', res))
    );
  }

  // getCenterService() {
  //     return this.http.get(`${API_PATH}/front/center-services`).pipe(
  //         map((res: any) => res.data),
  //         tap((res: any) =>
  //             this.loggingService.warn('[GET] getCenterService :: =>', res)
  //         )
  //     );
  // }
  getCenterService(visibility?: 'grip' | 'toyo' | 'nitto' | 'nankang' | 'advance', province?: string) {
    // const params = visibility ? `?visibility=${visibility}` : '';

    return this.http.get(`${NG_APP_API_ENDPOINT}/center-services?visibility=${visibility}&province=${province}`).pipe(
      map((res: any) => res.data),
      tap((res: any) => this.loggingService.warn('[GET] getCenterService :: =>', res))
    );
  }
  postForm(formData: any) {
    return this.http.post(`${NG_APP_API_ENDPOINT}/tire-warranty/save`, formData).pipe(
      map((res: any) => res), // Assuming `data` contains the relevant response
      tap((res: any) => this.loggingService.warn('[POST] Tire Warranty Save :: =>', res))
    );
    // return of(formData);
  }
  // postImage(formData: any) {
  //     return this.http.post(`${API_PATH}/front/image/upload`, formData).pipe(
  //         map((res: any) => res), // Assuming `data` contains the relevant response
  //         tap((res: any) => this.loggingService.warn('[POST] Tire Warranty postImage :: =>', res))
  //     );
  // }
  postImage(formData: FormData) {
    return this.http.post(`${NG_APP_API_ENDPOINT}/image/upload`, formData).pipe(
      map((res: any) => res), // Process response if needed
      tap((res: any) => this.loggingService.warn('[POST] Tire Warranty postImage :: =>', res))
    );
  }
  //     this.http.post<any>('https://tsc-api-dev.connecit.net/api/front/image/upload', this.selectedFile.name, )
  //     .subscribe({
  //       next: (response) => {
  //         this.loggingService.log('File uploaded successfully', response);
  //         if (response.status === 1) {
  //           // Set the file info from the API response
  //           this.fileInfo = response.data;
  //         this.loggingService.error('response', response);

  //         }
  //       },
  //       error: (error) => {
  //         this.loggingService.error('Error uploading file:', error);
  //       }
  //     });
}
